import React, {useContext, useEffect, useState} from "react";
import {AuthContext} from "../../context/AuthContext";
import {
    Button,
    Card,
    CardContent,
    Checkbox,
    ClickAwayListener,
    FormControlLabel,
    IconButton,
    Typography
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import {doc, updateDoc} from "firebase/firestore";
import {db} from "../../Firebase";
import {kLibrettoUserCollectionName} from "../../utils/CollectionConstants";


const LibrettoV2PopupCard = ({ onClose, userId, isLifetimePlanUser }) => {
    const [responded, setResponded] = useState(false);

    useEffect(() => {
        const markPopupSeen = async () => {
            const entityRef = doc(db, kLibrettoUserCollectionName, userId);
            try {
                await updateDoc(entityRef, { hasSeenAppSumoPopup: true });
                console.log("Updated hasSeenLibrettoV2Popup to true for user: ", userId);
            } catch (error) {
                console.error("Error updating hasSeenLibrettoV2Popup: ", error);
            }
        };

        markPopupSeen();
    }, [userId]);

    const handleResponse = async (notifyMe) => {
        setResponded(true); // Optional: could use to disable buttons

        const entityRef = doc(db, kLibrettoUserCollectionName, userId);
        try {
            await updateDoc(entityRef, { notifyMeOnLaunch: notifyMe });
            console.log("notifyMeOnLaunch updated to: ", notifyMe);
        } catch (error) {
            console.error("Error updating notifyMeOnLaunch: ", error);
        }
        onClose(); // Close after response
    };

    return (
        <Box
            sx={{
                position: "fixed",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "720px",
                padding: "40px 40px 32px",
                display: "flex",
                flexDirection: "column",
                gap: "32px",
                borderRadius: "16px",
                zIndex: 1000,
                background: "#FFFFFF",
                fontFamily: "Inter",
                boxShadow: "0 8px 40px rgba(0, 0, 0, 0.2)",
                borderTop: "6px solid #2B6BFD",
            }}
        >
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                    <Typography sx={{ fontSize: "22px", fontWeight: 700, color: "#1A1A1A" }}>
                        Libretto V2 is coming in October 🚀
                    </Typography>
                    <Typography sx={{ fontSize: "18px", fontWeight: 500, color: "#2B6BFD" }}>
                        Made for spoken-word creators: podcasts, interviews, and video stories.
                    </Typography>
                    <Typography sx={{ fontSize: "16px", fontWeight: 400, color: "#555", maxWidth: "580px" }}>
                        Rebuilt from the ground up to be faster, simpler and more reliable.
                    </Typography>
                    {isLifetimePlanUser && (
                        <>
                            <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#555" }}>
                                Thank you for being a lifetime plan buyer 🙌 We know it’s taken longer than expected to deliver on the promise of a true Descript alternative, and our hope is that Libretto V2 finally does just that.
                            </Typography>
                            <Typography sx={{ fontSize: "16px", fontWeight: 500, color: "#555" }}>
                                If you’re tired of waiting or feel let down, just email contact@libretto.fm and we’ll be glad to issue a refund.
                            </Typography>
                        </>
                    )}
                </Box>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "16px", alignItems: "center" }}>
                <Typography sx={{ fontSize: "17px", fontWeight: 500, color: "#1A1A1A", textAlign: "center" }}>
                    Would you like to be notified when Libretto V2 launches?
                </Typography>
                <Box sx={{ display: "flex", gap: "16px" }}>
                    <Button
                        variant="contained"
                        onClick={() => handleResponse(true)}
                        sx={{
                            backgroundColor: "#2B6BFD",
                            padding: "10px 20px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            fontSize: "15px",
                            textTransform: "none",
                            "&:hover": { backgroundColor: "#1F5BE0" },
                        }}
                    >
                        Yes, notify me
                    </Button>
                    <Button
                        variant="outlined"
                        onClick={() => handleResponse(false)}
                        sx={{
                            padding: "10px 20px",
                            fontWeight: 600,
                            borderRadius: "8px",
                            fontSize: "15px",
                            textTransform: "none",
                            borderColor: "#CCC",
                            color: "#333",
                            "&:hover": {
                                backgroundColor: "#f5f5f5",
                            },
                        }}
                    >
                        No, thanks
                    </Button>
                </Box>
            </Box>
        </Box>
    );
};

export default LibrettoV2PopupCard;